import { axiosClient, getToken } from '../../Config/axiosConfig';

export const getTipoUso = async () => {
	await getToken();
	return await axiosClient.get(`/tipoUso`);
};
